"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _theme = _interopRequireDefault(require("../Theme/lib/AirasiaMove/theme"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _flatbed_icon = _interopRequireDefault(require("../Icon/statics/flatbed_icon"));
var _flatbed_bundled_icon = _interopRequireDefault(require("../Icon/statics/flatbed_bundled_icon"));
var _flatbed_selected_icon = _interopRequireDefault(require("../Icon/statics/flatbed_selected_icon"));
var _flatbed_unavailable_icon = _interopRequireDefault(require("../Icon/statics/flatbed_unavailable_icon"));
var _bassinet_icon = _interopRequireDefault(require("../Icon/statics/bassinet_icon"));
var _constant = require("./constant");
var _flatbedTile = _interopRequireDefault(require("./flatbedTile.proptypes"));
var _constant2 = require("../SeatTile/constant");
var _excluded = ["theme", "accessible", "status", "centerText", "onClick", "size", "centerIcon", "topIcon", "tileSize", "topIconSpacing"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var FlatbedWrapper = _styledComponents.default.div.withConfig({
  displayName: "FlatbedTile__FlatbedWrapper",
  componentId: "sc-7qkdhs-0"
})(["display:inline-flex;flex-direction:column;", " ", ""], function (_ref) {
  var onClick = _ref.onClick;
  return onClick && "cursor: pointer;";
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && "cursor: not-allowed;";
});
var TopIconWrapper = _styledComponents.default.div.withConfig({
  displayName: "FlatbedTile__TopIconWrapper",
  componentId: "sc-7qkdhs-1"
})(["width:", ";height:", ";display:flex;justify-content:center;align-items:flex-end;"], function (_ref3) {
  var tileLength = _ref3.tileLength;
  return tileLength;
}, function (_ref4) {
  var topIconHeight = _ref4.topIconHeight;
  return topIconHeight;
});
var FlatbedTile = function FlatbedTile(props) {
  var theme = props.theme,
    accessible = props.accessible,
    status = props.status,
    centerText = props.centerText,
    onClick = props.onClick,
    size = props.size,
    centerIcon = props.centerIcon,
    topIcon = props.topIcon,
    tileSize = props.tileSize,
    topIconSpacing = props.topIconSpacing,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var lineHeight = _theme.default.lineHeight;
  var text = centerText === null || centerText === void 0 ? void 0 : centerText.toUpperCase().substring(0, 2);
  var ariaLabel = _constant.FLATBED_LABEL[status];
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var isSelected = status === _constant.FLATBED_STATUS.SELECTED;
  var isUnavailable = status === _constant.FLATBED_STATUS.UNAVAILABLE;
  var tileLength = lineHeight[tileSize];
  var topIconHeight = lineHeight[topIconSpacing];
  var NormalTile = function NormalTile() {
    return /*#__PURE__*/_react.default.createElement(_flatbed_icon.default, {
      fontsize: size,
      "aria-label": ariaLabel
    });
  };
  var UnavailableTile = function UnavailableTile() {
    return /*#__PURE__*/_react.default.createElement(_flatbed_unavailable_icon.default, {
      fontsize: size,
      "aria-label": ariaLabel
    });
  };
  var SelectedTile = function SelectedTile() {
    return /*#__PURE__*/_react.default.createElement(_flatbed_selected_icon.default, {
      fontsize: size,
      text: text,
      "aria-label": ariaLabel
    });
  };
  var BundledTile = function BundledTile() {
    return /*#__PURE__*/_react.default.createElement(_flatbed_bundled_icon.default, {
      fontsize: size,
      ariaLabel: ariaLabel
    });
  };
  var getTile = function getTile() {
    if (isSelected) return /*#__PURE__*/_react.default.createElement(SelectedTile, null);
    if (isUnavailable) return /*#__PURE__*/_react.default.createElement(UnavailableTile, null);
    if (centerIcon === _constant.SEAT_CENTER_ICON.STAR_ICON) return /*#__PURE__*/_react.default.createElement(BundledTile, null);
    return /*#__PURE__*/_react.default.createElement(NormalTile, null);
  };
  var getTopIcon = function getTopIcon() {
    // always show if there's bassinet from the seat
    if (topIcon === _constant2.SEAT_TOP_ICON.BASSINET_ICON) {
      return /*#__PURE__*/_react.default.createElement(TopIconWrapper, {
        tileLength: tileLength,
        topIconHeight: topIconHeight
      }, /*#__PURE__*/_react.default.createElement(_bassinet_icon.default, {
        fontsize: "medium",
        themeColor: "greyDark",
        "aria-label": "Bassinet icon"
      }));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(FlatbedWrapper, (0, _extends2.default)({
      tabIndex: accessible ? 0 : -1,
      onClick: onClick,
      onKeyPress: function onKeyPress(e) {
        if (e.key === 'Enter') onClick();
      }
    }, rest, {
      disabled: isUnavailable
    }), getTopIcon(), getTile());
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
FlatbedTile.propTypes = _flatbedTile.default.PropTypes;
FlatbedTile.defaultProps = _flatbedTile.default.DefaultProps;
var _default = FlatbedTile;
exports.default = _default;